export default __webpack_public_path__ + "static/media/facebook-white.2988e2ca.svg";